import styled from '@emotion/styled'
import { colors } from 'Constants'
import { SectionHeader } from 'Components/Section'

export default styled.div`
  display: contents;

  > * {
    padding: 16px 8px;
    align-self: stretch;
    break-before: always;
  }

  strong {
    font-weight: bold;
    font-size: 1.4em;
  }

  ${SectionHeader} {
    justify-self: end;
    align-self: center;
  }

  &:nth-of-type(2n + 1) > * {
    ${({ noBackground }) =>
      !noBackground && `background: ${colors.background800};`}
  }

  &:nth-of-type(2n) > * {
    ${({ noBackground }) =>
      !noBackground && `background: ${colors.background700};`}
  }

  @media print {
    * {
      padding: 8px 4px;
    }
  }
`
